import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sm-calender-dialog',
  templateUrl: './calender-dialog.component.html',
  styleUrls: ['./calender-dialog.component.scss']
})
export class CalenderDialogComponent implements OnInit {
  selectedDate: Date | null = null;   // bound to [(selected)]
  startAt: Date | null = null;        // replace activeDate with startAt

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private calDialogRef: MatDialogRef<CalenderDialogComponent>
  ) {}

  ngOnInit(): void {
    this.startAt = this.data?.selectedDate ?? new Date();
    this.selectedDate = null; // so clicking the same date will trigger selectedChange
  }

  onDateSelection(date: Date) {
    this.calDialogRef.close(date);
  }
}
